import http from '../jslibs/axios/http';

//友情链接列表
export  const getLinkList = data => (http.get('/v1/cms/FriendlyLink', data));

//添加友情链接
export  const addLinkList = data => (http.post('/v1/cms/FriendlyLink', data));

//编辑友情链接
export  const editLinkList = data => (http.put(`/v1/cms/FriendlyLink/${data.id}`, data));

//删除友情链接
export  const deleteLinkList = id => (http.delete(`/v1/cms/FriendlyLink/${id}`));